import { useRef, type ReactNode } from "react";
import { X } from "lucide-react";
import { Button } from "./button";
import { useModalFocus } from "./useModalFocus";

export function Dialog({ title, onClose, children, wide = false }: { title: string; onClose: () => void; children: ReactNode; wide?: boolean }) {
  const panelRef = useRef<HTMLDivElement>(null);
  useModalFocus(panelRef, onClose, "input:not([type='hidden']), textarea, button:not(.dialog__close), select");
  return (
    <div className="dialog-backdrop" onMouseDown={(event) => { if (event.target === event.currentTarget) onClose(); }}>
      <div className={wide ? "dialog dialog--wide" : "dialog"} role="dialog" aria-modal="true" aria-label={title} ref={panelRef}>
        <header className="dialog__header">
          <h2>{title}</h2>
          <Button size="icon" variant="ghost" className="dialog__close" aria-label="Close" onClick={onClose}><X size={16} /></Button>
        </header>
        <div className="dialog__body">{children}</div>
      </div>
    </div>
  );
}
